export const SKIP_ERROR_URL: Record<string, string> = {
  "/employee_registration": "Skip this error",
};
